var api = {};

if (process.env.NODE_ENV !== 'production') {
  api.clientUri = "http://localhost:4000"
} else {
  api.clientUri = "https://politicians-api.informatik.koeln"
}
export default api;
